// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_fk","advertDetailParameterList__header":"c-q_fl","advertDetailParameterList__list":"c-q_fm"};